module.exports = __webpack_public_path__ + "img/cpt-fp.47f10651.png";